import { render, staticRenderFns } from "./VSeoPagination.vue?vue&type=template&id=78825c78"
import script from "./VSeoPagination.vue?vue&type=script&lang=js"
export * from "./VSeoPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports